module.exports = __webpack_public_path__ + "static/media/half-car-mobile.aaef43b9.png";